import useAuthentication from "@hooks/useAuthentication";
import ConsentFormV1 from "./v1";
import ConsentFormV2 from "./v2";



const ConsentFormGrants = () => {
  const { user } = useAuthentication();
   const hasV2Access = user?.region=== "QATAR_REGION" 

  // example grant checks – adjust to your backend structure

  return hasV2Access ? <ConsentFormV2 /> : <ConsentFormV1/>;
};

export default ConsentFormGrants;
